"use client";
import type { ReactNode } from "react";
import { createContext, useCallback, useContext, useState } from "react";

type HeaderContextData = {
  openId?: string | undefined;
  setOpenId?: (openId: string) => void;
};
const context = createContext<HeaderContextData>({});

const Provider = context.Provider;

export const HeaderContext = ({ children }: { children: ReactNode }) => {
  const [openId, setOpenId] = useState<string | undefined>();
  const setOpenIdContext = useCallback(
    (tabId: string) => {
      setOpenId(() => (tabId === openId ? undefined : tabId));
    },
    [setOpenId, openId],
  );

  return (
    <Provider
      value={{
        openId,
        setOpenId: setOpenIdContext,
      }}
    >
      {children}
    </Provider>
  );
};
export const useHeaderContext = () => useContext(context);
